import Visa from './Visa';

export default Visa;
